import { render, staticRenderFns } from "./shipmentInfoModal.vue?vue&type=template&id=3848403c&scoped=true&"
import script from "./shipmentInfoModal.vue?vue&type=script&lang=js&"
export * from "./shipmentInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./shipmentInfoModal.vue?vue&type=style&index=0&id=3848403c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848403c",
  null
  
)

export default component.exports